/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import DescTaskInputs from './DescTaskInputs';
import CheckTaskInputs from './CheckTaskInputs';
import TimeTargetTaskInputs from './TimeTargetTaskInputs';
import GeoTargetTaskInputs from './GeoTargetTaskInputs';
import ExecOptionsTaskInputs from './ExecOptionsTaskInputs';
import PerformersTaskInputs from './PerformersTaskInputs';
import CostsTaskInputs from './CostsTaskInputs';

// TODO Нет css для back, времянка, сделать нормально
class TaskFrom extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="pos-rel">
          {this.context.router.history.length > 2 ? (
            <a
              onClick={e => {
                e.preventDefault();
                this.context.router.history.goBack();
              }}
              className="page-back"
              href=""
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                display: 'table',
                color: '#aaa',
                fontSize: '18px'
              }}
            >
              <i className="fa fa-angle-left fa-2x" />
              <span
                className="page-back-title"
                style={{
                  display: 'table-cell',
                  verticalAlign: 'middle',
                  paddingLeft: '5px'
                }}
              >
                {t('Назад')}
              </span>
            </a>
          ) : null}
          <h1 className="page-header h2">
            {this.props.hasNewTask ? (
              <React.Fragment>
                <i className="fa fa-lg fa-plus-circle" />{' '}
                <strong>{t('Новое задание')}</strong>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <i className="fa fa-lg fa-pencil" />{' '}
                <strong>{t('Редактирование задания')}</strong>
              </React.Fragment>
            )}
          </h1>
        </div>
        <DescTaskInputs {...this.props} />
        <ExecOptionsTaskInputs {...this.props} />
        <CheckTaskInputs {...this.props} />
        <TimeTargetTaskInputs {...this.props} />
        <GeoTargetTaskInputs {...this.props} />
        <PerformersTaskInputs {...this.props} />
        <CostsTaskInputs {...this.props} />
      </React.Fragment>
    );
  }
}

TaskFrom.propTypes = {
  hasNewTask: PropTypes.bool.isRequired
};

TaskFrom.contextTypes = {
  router: PropTypes.shape()
};

export default TaskFrom;



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/TaskFrom.js